import { createSelector } from "@reduxjs/toolkit"

import { useAppSelector } from "../../../store"

import { albumsPersonSelectors } from "./albumPersonSlice"

const ITEMS_COUNT_NAME = 'live_items_count'

const isAlbumVisible = (value: number) => value > 1

const filterEmptyAlbums = (albums: any[], fieldName = ITEMS_COUNT_NAME) => albums.filter(album => isAlbumVisible(album[fieldName])).sort((a, b) => b.items_count - a.items_count)

export const getAlbumsPersonItemsSelector =  state => albumsPersonSelectors.selectAll(state.albumsPerson)

export const getAlbumsPersonItems = () => useAppSelector(getAlbumsPersonItemsSelector)

export const getAlbumsPersonWithNoneZeroContentSelector = createSelector(getAlbumsPersonItemsSelector, (albums) => filterEmptyAlbums(albums))

export const getAlbumsPersonWithNoneZeroContent = () => useAppSelector(getAlbumsPersonWithNoneZeroContentSelector)

export const getAlbumsPersonStatus = () => useAppSelector(state => state.albumsPerson.status)
